export function validateItau(agencyNumber, accountNumber, givenCheckDigit) {
  // This script cannot  validate itau accounts with more than 5 digits
  if (accountNumber.length > 5) {
    return true;
  }
  if (agencyNumber.length < 4) {
    agencyNumber = agencyNumber.padStart(4, '0');
  }
  if (accountNumber.length < 5) {
    accountNumber = accountNumber.padStart(5, '0');
  }
  return calculate(agencyNumber, accountNumber) == givenCheckDigit;
}

function calculate(agencyNumber, accountNumber) {
  const numbers = (agencyNumber + accountNumber).split('');
  let sumSeq = 0;
  let sequence = 0;
  for (let i = 0; i < numbers.length; i++) {
    const number = parseInt(numbers[i], 10);
    sequence = multiplyAccordingParity(number, i);
    sequence = adjustAccordingLength(sequence);
    sumSeq += sequence;
  }
  return module(sumSeq);
}

function multiplyAccordingParity(number, index) {
  return number * (index % 2 === 0 ? 2 : 1);
}

function adjustAccordingLength(sequence) {
  if (sequence > 9) {
    const numbers = sequence.toString().split('');
    sequence = 0;
    for (let i = 0; i < numbers.length; i++) {
      sequence += parseInt(numbers[i], 10);
    }
  }
  return sequence;
}

function module(sumSeq) {
  const module = sumSeq % 10;
  if (module === 0) {
    return '0';
  }
  return (10 - module).toString();
}
